<template>
  <div class="FormRecommendation">
    <RowGrid :columns="5">
      <Field
        :value="item.name"
        @update:value="$up('item.name', $event)" />
      <Field
        type="number"
        :value="item.price"
        @update:value="$up('item.price', $event)" />
      <Btn class="danger sm ib inv noBorder" @click="$emit('remove')">
        <Icon name="cross" />
      </Btn>
    </RowGrid>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.FormRecommendation {
  border-bottom: 1px solid $border-color;
  margin-bottom: $grid-unit-half;

  .Field-cont {
    margin: 0;
  }
}
</style>
